import React, { useState, useLayoutEffect, useRef } from "react";
import Navbar from "../Common/Navbar";
import SideMenu from "../Common/SideMenu";
import { CgProfile } from "react-icons/cg";
import { MdSpaceDashboard } from "react-icons/md";
import { FaRegCircleUser, FaWallet, FaTableList } from "react-icons/fa6";

const Layout = ({ children }) => {
  const layoutRef = useRef(null);
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth >= 768;
  });

  const [user, setUser] = useState(null);

  console.log("isOpen", isOpen);

  useLayoutEffect(() => {
    // This runs BEFORE browser repaint, but AFTER DOM is ready
    setIsOpen(window.innerWidth >= 768);

    const userData = localStorage.getItem("user");
    setUser(JSON.parse(userData));

    const handleResize = () => {
      setIsOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    { path: "/", label: "Dashboard", Icon: MdSpaceDashboard },
    { path: "/user-list", label: "User List", Icon: FaRegCircleUser },
    { path: "/transactions", label: "Transactions", Icon: FaTableList },
  ];

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div
        className={`fixed top-[68px] left-0 h-[calc(100%-68px)] bg-white border-r border-[#142b701a] transition-all duration-300 z-40
  ${isOpen ? "translate-x-0" : "-translate-x-full"} w-64 md:translate-x-0`}
      >
        <SideMenu menuItems={menuItems} setIsOpen={setIsOpen} />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 w-full">
        <div className="fixed top-0 left-0 right-0 z-40">
          <Navbar toggleSidebar={() => setIsOpen(!isOpen)} user={user} />
        </div>

        {/* Push content below navbar */}
        <main
          className={`mt-[68px] transition-all duration-300 p-3 md:p-6 bg-[#f9f9f9] min-h-[calc(100vh-68px)] overflow-y-scroll ${
            isOpen ? "md:ml-64" : "md:ml-16"
          }`}
          ref={layoutRef}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
